import { useEffect } from 'react'
import { useAuthStore } from '../store/auth'
import { identify } from '../lib/analytics'

/**
 * Identifies the current user to analytics (PostHog + LogRocket) whenever a user
 * is present. Covers both fresh logins and page reloads — on reload the persisted
 * user is restored from the auth store, but LogRocket identity is per-page-load,
 * so without this every reloaded session would show as "anonymous user".
 */
export function AnalyticsIdentity() {
  const user = useAuthStore((s) => s.user)
  useEffect(() => {
    if (!user) return
    identify(user.id, {
      email: user.email,
      role: user.role,
      displayName: user.displayName,
    })
  }, [user])
  return null
}
